var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from "react";
import Box from "@mui/material/Box";
import { Delimiter } from "../../atoms/Delimiter";
import { Formik, Form } from "formik";
import { TextField } from "@mui/material";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import Typography from "@mui/material/Typography";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import styled, { keyframes } from "styled-components";
const rotate = keyframes `
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;
const RotatingIcon = styled(AutorenewIcon) `
  animation: ${rotate} 1s linear infinite;
`;
const commonModalStyles = {
    padding: "30px",
    maxWidth: "668px",
    maxHeight: "calc(100vh - 200px)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
};
const normalize = (s) => s.replace(/\s+/g, " ").trim();
export const PlayerNameEditing = ({ player, onSubmit, onClose, }) => {
    var _a, _b;
    if (!player)
        return null;
    const initialRealName = (_a = player.player.realName) !== null && _a !== void 0 ? _a : "";
    const initialGameName = (_b = player.player.gameName) !== null && _b !== void 0 ? _b : "";
    const handleSubmit = useCallback((values, actions) => __awaiter(void 0, void 0, void 0, function* () {
        const realName = normalize(values.realName);
        const gameName = normalize(values.gameName);
        // Check if anything changed
        const realNameChanged = realName !== normalize(initialRealName);
        const gameNameChanged = gameName !== normalize(initialGameName);
        if (!realName || !gameName || (!realNameChanged && !gameNameChanged)) {
            actions.setSubmitting(false);
            return;
        }
        yield onSubmit({
            id: player.id,
            realName,
            gameName,
        });
        actions.setSubmitting(false);
        onClose();
    }), [initialRealName, initialGameName, onSubmit, onClose, player]);
    return (_jsxs(Box, Object.assign({ sx: commonModalStyles }, { children: [_jsx(Delimiter, { top: "20px" }), _jsx(Typography, Object.assign({ variant: "h4" }, { children: "\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u0438\u0433\u0440\u043E\u043A\u0430" })), _jsx(Delimiter, { top: "20px" }), _jsx(Formik, Object.assign({ initialValues: { realName: initialRealName, gameName: initialGameName }, onSubmit: handleSubmit }, { children: ({ values, setFieldValue, isSubmitting, handleSubmit }) => {
                    const realNameNorm = normalize(values.realName);
                    const gameNameNorm = normalize(values.gameName);
                    const realNameChanged = realNameNorm !== normalize(initialRealName);
                    const gameNameChanged = gameNameNorm !== normalize(initialGameName);
                    const disabled = isSubmitting ||
                        !realNameNorm ||
                        !gameNameNorm ||
                        (!realNameChanged && !gameNameChanged);
                    return (_jsxs(Form, Object.assign({ onSubmit: handleSubmit }, { children: [_jsx(TextField, { autoFocus: true, fullWidth: true, variant: "outlined", label: "\u0418\u043C\u044F", placeholder: "\u0418\u043C\u044F", value: values.realName, onChange: (e) => setFieldValue("realName", e.target.value), inputProps: {
                                    autoCapitalize: "words",
                                    autoCorrect: "off",
                                    spellCheck: "false",
                                    maxLength: 64,
                                }, sx: { marginBottom: "16px" } }), _jsx(TextField, { fullWidth: true, variant: "outlined", label: "\u0418\u0433\u0440\u043E\u0432\u043E\u0439 \u043D\u0438\u043A", placeholder: "\u0418\u0433\u0440\u043E\u0432\u043E\u0439 \u043D\u0438\u043A", value: values.gameName, onChange: (e) => setFieldValue("gameName", e.target.value), onKeyDown: (e) => {
                                    if (e.key === "Enter") {
                                        e.preventDefault();
                                        handleSubmit();
                                    }
                                }, inputProps: {
                                    enterKeyHint: "done",
                                    autoCapitalize: "none",
                                    autoCorrect: "off",
                                    spellCheck: "false",
                                    maxLength: 64,
                                } }), _jsx(Delimiter, { top: "20px" }), _jsx(FormControl, { children: _jsx(Button, Object.assign({ type: "submit", variant: "contained", disabled: disabled, startIcon: isSubmitting ? _jsx(RotatingIcon, {}) : undefined }, { children: isSubmitting ? "Сохраняю…" : "Сохранить" })) })] })));
                } }))] })));
};
